import HeaderMenu from 'components/header/HeaderMenu';
import { useClickOutside } from 'hooks/useClickOutside';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const MobileHeaderMenu: React.FC = () => {
  const { t } = useTranslation();
  const [isShowHeaderMenu, setIsShowHeaderMenu] = useState<boolean>(false);
  const handleToggleHeaderMenu = () => setIsShowHeaderMenu((prevState) => !prevState);
  const handleCloseHeaderMenu = () => setIsShowHeaderMenu(false);

  const openHeaderMenuBtnRef = useClickOutside(handleCloseHeaderMenu);

  return (
    <>
      <div className='flex ml-auto flex-shrink-0 lg:hidden lg:order-2'>
        <button
          ref={openHeaderMenuBtnRef}
          className='flex flex-col items-center justify-center space-y-1 hover:text-hl-primary focus:outline-none overflow-hidden relative'
          onClick={handleToggleHeaderMenu}
        >
          <svg
            data-slot='icon'
            fill='none'
            strokeWidth='1.5'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
            aria-hidden='true'
            className='w-7 h-7'
          >
            <path strokeLinecap='round' strokeLinejoin='round' d='M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5'></path>
          </svg>
        </button>
      </div>
      <div
        aria-label={isShowHeaderMenu ? 'backdrop' : ''}
        className={[
          'fixed top-0 w-screen h-screen  transition-all duration-300 ease-in-out z-10 bg-hl-dark/50 lg:hidden',
          isShowHeaderMenu ? 'left-0' : '-left-full'
        ].join(' ')}
      >
        <div className='w-3/4 bg-white h-full'>
          {isShowHeaderMenu ? (
            <button className='w-1/2 bg-hl-dark p-4 uppercase text-white outline-0 border-none flex justify-center items-center focus:outline-0'>
              <svg
                data-slot='icon'
                fill='none'
                strokeWidth='1.5'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
                className='w-6 h-6'
              >
                <path strokeLinecap='round' strokeLinejoin='round' d='M3.75 6.75h16.5M3.75 12H12m-8.25 5.25h16.5'></path>
              </svg>
              <span className='ml-3 text-xs'>{t('labels.menu')}</span>
            </button>
          ) : (
            <></>
          )}
          {/** INFO: 56px is the  button top height; 48px is the close button height */}
          <HeaderMenu className='h-[calc(100%-56px-48px)] header-menu__mobile' />
          <button className='w-full bg-hl-primary text-white p-4 text-center uppercase text-xs mt-auto'>{t('labels.close')}</button>
        </div>
      </div>
    </>
  );
};
